import { createFileRoute } from '@tanstack/react-router';
import { JourneysWizardStepHandoff } from '@/pages/workspaces/imports/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';
import { validateWizardSearch } from './-import-wizard-search';

/** The legacy preprocessing URL. Flag off the embedded app renders; flag on it forwards to the migrated one. */
function JourneysImportPreprocessingRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysWizardStepHandoff step="preprocessing" />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/preprocessing',
)({
  validateSearch: validateWizardSearch,
  component: JourneysImportPreprocessingRoute,
});
